export default "__VITE_ASSET__D80Q2LGr__"